import React, { useEffect, useState, useRef } from 'react';
interface LazyMountProps {
  children: React.ReactNode;
  minHeight?: number;
  rootMargin?: string;
  id?: string;
}
export function LazyMount({
  children,
  minHeight = 600,
  rootMargin = '600px',
  id
}: LazyMountProps) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (show || typeof window === 'undefined') return;
    const el = ref.current;
    if (!el) return;
    if (!('IntersectionObserver' in window)) {
      setShow(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        setShow(true);
        observer.disconnect();
      }
    }, {
      rootMargin
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [show, rootMargin]);
  return <div ref={ref} id={id} style={show ? undefined : {
    minHeight
  }} data-id="element-147">
      {show ? children : null}
    </div>;
}